import State from "slotworks/state-machine/states/state";
import RespinComponent from "components/respin/respin-component";
import gameState from "slotworks/model/game-state";
import RainbowStacksEnterFreespins from "./enter-freespins";
import RainbowStacksRespinRecord from "integration/revolver/schema/respin-record";
import regulation from "slotworks/integration/revolver/regulations/regulation";
import Contract from "slotworks/utils/contract";
import Components from "slotworks/components/components";
import HidePromoFSonFreespins from "slotworks/commands/promo-free-spins/hide-pfs-on-freespins";
import RainbowStacksFreespinRecord from "integration/revolver/schema/freespin-record";
import smartButton, { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import betModel from "slotworks/model/bets/bet-model";
import { BetBarType } from "slotworks/components/betbar/bet-bar-component";
import BetMenuFreespinsMediator from "slotworks/mediators/bet-menu-freespins-mediator";
import FlexiButton from "slotworks/graphics/elements/flexi-button";
import Layers from "slotworks/graphics/layers/layers";
import settingsModel from "slotworks/model/settings/settings-model";
import translations from "slotworks/i18n/translations";
import { ShowFreespinsElements } from "commands/freespins";
import { HideUIButtons } from "commands/ui-buttons";

export default class RecoverRespins extends State {
    
    private homeButton: FlexiButton;
    private homeURL: string;
    
    public onEnter() {
        regulation.interactionStart();

        const record = gameState.getCurrentGame().getCurrentRecord() as RainbowStacksRespinRecord;
        if(record.inFreespins) {
            this.recoverFreespinElements().then(() => this.complete());
        } else 
            this.complete();
    }

    private recoverElements() {
        
    }

    private recoverFreespinElements():Contract<void> {
        const gameplay = gameState.getCurrentGame();
        const record = gameplay.records[0] as RainbowStacksFreespinRecord;

        gameState.getCurrentGame().inFreespinsGame = true;

        // Increase remaining free spins and take away any won on this spin to simulate what count would be on previous result (which we don't have)
        const actualFreespins = record.remainingFreespins;
        record.remainingFreespins++;
        record.remainingFreespins -= record.freespinsWon;

        // if campaing is active we change the way smart button works to regular freespins
        HidePromoFSonFreespins();
        
        // Update smart button count
        smartButton.setFlag(SmartButtonFlag.FREE_SPINS, true);

        Components.betBar.setBetOptions(betModel.generateBetOptions());
        Components.betBar.setType(BetBarType.FREESPINS);
        new BetMenuFreespinsMediator().start().execute();

        // Reset back to correct free spin count
        record.remainingFreespins = actualFreespins;

        Components.betBar.winnings.setWinnings(0, gameplay.getRunningFreespinsWinTotal() - gameplay.getCurrentRecord().creditsWon);
        this.homeButton = Layers.BetBar.getFlexiButton("home");
        this.homeURL = settingsModel.homeURL;
        if (this.homeButton) {
            if (this.homeURL === "close" || this.homeURL === "" || this.homeURL === undefined || this.homeURL === null) {
                this.homeButton.setVisible(false);
            } else {
                this.homeButton.setVisible(true);
            }
        }
        Components.betBar.setEnabled(false);
        ShowFreespinsElements();
        HideUIButtons();

        const contents = new Map<string, string>();
        contents.set("body", translations.get("rec.fre"));

        return Components.prompt.show(["info", "error"], contents);
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/states/recover-respins.ts